// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__16ldY","errorLogs":"EditorFooter_errorLogs__1kv02"};